/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_To_StageInputs */

const cs_field_to_stage = /** @type {(inputs: Field_To_StageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cílová fáze`)
};

const en_field_to_stage = /** @type {(inputs: Field_To_StageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Target stage`)
};

/**
* | output |
* | --- |
* | "Target stage" |
*
* @param {Field_To_StageInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_to_stage = /** @type {((inputs?: Field_To_StageInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_To_StageInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_to_stage(inputs)
	return cs_field_to_stage(inputs)
});